export const frMrgaClaimsHistoryDurations = [
  'less_than_12_months',
  'between_12_and_23_months',
  'between_24_and_35_months',
  'at_least_36_months',
] as const

export type FrMrgaClaimsHistoryDuration = (typeof frMrgaClaimsHistoryDurations)[number]

export const frMrgaLargestClaims = ['none_above_5000', 'between_5000_and_20000', 'above_20000'] as const

export type FrMrgaLargestClaim = (typeof frMrgaLargestClaims)[number]
